export default function WorkflowIndicator({ current, total, onPrevious, onNext }) {
    const isAtStart = total === 0 || current === 0;
    const isAtEnd = total === 0 || current === total - 1;

    return (
        <div className="workflow-container">
            <span
                className="fas fa-angle-left fa-xl colour-primary"
                style={{ cursor: isAtStart ? 'default' : 'pointer', opacity: isAtStart ? 0.4 : 1 }}
                onClick={isAtStart ? undefined : onPrevious}
            ></span>
            <span>{total === 0 ? 0 : current + 1}/{total}</span>
            <span
                className="fas fa-angle-right fa-xl colour-primary"
                style={{ cursor: isAtEnd ? 'default' : 'pointer', opacity: isAtEnd ? 0.4 : 1 }}
                onClick={isAtEnd ? undefined : onNext}
            ></span>
        </div>
    )
}
